(function () {
  document.addEventListener("DOMContentLoaded", () => {
    console.debug("[subscription-widget] DOMContentLoaded");

    // 1. Find the single main quantity block we want to move
    const mainQtyBlock = document.querySelector("#MainQuantityBlock");
    if (!mainQtyBlock) {
      console.warn("[subscription-widget] #MainQuantityBlock not found");
      return;
    }

    // 2. Find the subscription widget and its option boxes
    const widget = document.querySelector(
      "shrine-subscription-widget, .subscription-widget",
    );
    if (!widget) {
      console.warn("[subscription-widget] Subscription widget not found");
      return;
    }

    const oneTimeBox = widget.querySelector('[data-type="one_time"]');
    const subscriptionBox = widget.querySelector('[data-type="subscription"]');

    const oneTimeQtyWrapper = widget.querySelector(
      ".subscription__quantity--one-time",
    );
    const subscriptionQtyWrapper = widget.querySelector(
      ".subscription__quantity--subscription",
    );

    console.debug("[subscription-widget] Elements:", {
      oneTimeBox,
      subscriptionBox,
      oneTimeQtyWrapper,
      subscriptionQtyWrapper,
    });

    if (
      !oneTimeBox ||
      !subscriptionBox ||
      !oneTimeQtyWrapper ||
      !subscriptionQtyWrapper
    ) {
      console.warn("[subscription-widget] Missing boxes or quantity wrappers");
      return;
    }

    // 3. Helper to know which option is currently selected
    const isSubscriptionSelected = () =>
      subscriptionBox.classList.contains("subscription__box--selected") ||
      subscriptionBox.dataset.selected === "true";

    // 4. Move the main quantity block into the correct wrapper
    const moveQuantityBlock = () => {
      const subscriptionSelected = isSubscriptionSelected();
      const targetWrapper = subscriptionSelected
        ? subscriptionQtyWrapper
        : oneTimeQtyWrapper;

      if (!targetWrapper) return;

      // Only move if it's not already there
      if (mainQtyBlock.parentElement !== targetWrapper) {
        targetWrapper.appendChild(mainQtyBlock);
        console.debug("[subscription-widget] Moved MainQuantityBlock to", {
          subscriptionSelected,
          target: subscriptionSelected ? "subscription" : "one_time",
        });
      }
    };

    // 5. Initial placement based on preselected option
    moveQuantityBlock();

    // 6. When user clicks options, move the quantity block accordingly
    oneTimeBox.addEventListener("click", () => {
      requestAnimationFrame(moveQuantityBlock);
    });

    subscriptionBox.addEventListener("click", () => {
      requestAnimationFrame(moveQuantityBlock);
    });
  });
})();
